import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'redpoints-front-components/index';
import {
  withContext,
  withQueryParams,
} from 'redpoints-front-common/components';
import { redirect } from 'redpoints-front-common/helpers';

import {
  shortenerResolutionClearLinkToResolve,
  shortenerResolutionFetchLinkToResolve,
} from '../../../actions/shortenerResolutionActions';
import { getShortenerResolutionFiltersSelected } from '../../../reducers/tasks/shortenerResolution';
import { ROUTES } from '../../../config/constants';
import { translate } from '../../../helpers/languageHelper';

const redirectRoute = (domainUrl, filterByCustomer) => {
  redirect({
    queryParams: {
      domainUrl: domainUrl ? domainUrl : undefined,
      filterByCustomer,
    },
    queryParamsArrayFormat: null,
    urlRoute: ROUTES.SHORTENER_RESOLUTION,
  });
};

const ShortenerResolutionFiltersActions = ({
  customer: { customerId },
  filtersSelected,
  queryParams,
  shortenerResolutionClearLinkToResolve,
  shortenerResolutionFetchLinkToResolve,
}) => {
  const { domain, filterByCustomer } = filtersSelected;
  const customerIdToFetch = filterByCustomer ? customerId : undefined;

  const handleApply = () => {
    redirectRoute(domain?.url, filterByCustomer);

    shortenerResolutionFetchLinkToResolve({
      domainIds: domain?.domainId ? [domain.domainId] : undefined,
      customerId: customerIdToFetch,
    });
  };

  const handleClear = () => {
    redirectRoute();
    shortenerResolutionClearLinkToResolve();
  };

  const hasMinimumFiltersValues = Boolean(domain?.domainId);

  const isApplyDisabled =
    queryParams?.domainUrl === filtersSelected?.domain?.url &&
    String(filtersSelected?.filterByCustomer) === queryParams?.filterByCustomer;

  const isClearDisabled = !hasMinimumFiltersValues;

  return (
    <>
      <Button
        aria-label="button-apply"
        disabled={isApplyDisabled}
        onClick={handleApply}
        size="small"
        type="primary"
      >
        {translate('actions.apply')}
      </Button>
      <Button
        aria-label="button-clear"
        disabled={isClearDisabled}
        onClick={handleClear}
        size="small"
        type="secondary"
      >
        {translate('actions.clear')}
      </Button>
    </>
  );
};

const mapStateToProps = state => ({
  filtersSelected: getShortenerResolutionFiltersSelected(state),
});

export default compose(
  withContext,
  withQueryParams,
  connect(mapStateToProps, {
    shortenerResolutionClearLinkToResolve,
    shortenerResolutionFetchLinkToResolve,
  })
)(ShortenerResolutionFiltersActions);
